<template>
    <tr class="lms__superadmin_customer_edit_contacts_table_item">
        <td class="lms__superadmin_customer_edit_contacts_table_item_name">{{contactName}}</td>
        <td class="lms__superadmin_customer_edit_contacts_table_item_emailphone">
            <a :href="`mailto:${contactEmail}`">{{ contactEmail }}</a>
            <template v-if="contactEmail && contactPhone">
                <br>
            </template>
            <span>{{ contactPhone }}</span>
        </td>
        <td class="lms__superadmin_customer_edit_contacts_table_item_address">{{ contactAddress }}</td>
        <td class="lms__superadmin_customer_edit_contacts_table_item_notes">{{ contactNotes }}</td>
        <td class="lms__superadmin_customer_edit_contacts_table_item_actions">
            <div class="columns is-inline-flex has-text-right-mobile is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :theme="'default'"
                        :icon="true"
                        :icon-name="'trash-2'"
                        @click="performEmit('emit-remove', contactId)"
                        :name="'lms-superadmin-customer-edit-contacts-table-item-actions-remove'"></component-button>
                </div>
                <div class="column is-narrow">
                    <component-button
                        :name="'lms-superadmin-customer-edit-contacts-table-item-actions-edit'"
                        @click="performEmit('emit-edit', contactId)"
                    >{{ $t('lms.customer.buttons.edit') }}</component-button>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
export default {
  name: 'lms-superadmin-customer-edit-contacts-table-item',
  components: { ComponentButton },
  props: {
    item: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    contactAddress () {
      return this.item.address
    },
    contactEmail () {
      return this.item.email
    },
    contactId () {
      return this.item.id
    },
    contactName () {
      return this.item.name
    },
    contactNotes () {
      return this.item.notes
    },
    contactPhone () {
      return this.item.phone
    }
  },
  methods: {
    performEmit (message, value) {
      this.$emit('emit', { message: message, value: value })
    }
  }
}
</script>
